import { bss } from "@dashboard/base/BssService";
import type { BrandBssBinding } from "@dashboard/brands/brandConfig";

export function getBssValue(binding: BrandBssBinding | undefined): string {
  return binding ? bss.get(binding.key, binding.fallback ?? "") : "";
}
